import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { PlanoContaMatrizEditarComponent } from './plano-contas-matriz-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: PlanoContaMatrizEditarComponent }
    ])],
    exports: [RouterModule]
})
export class PlanoContaMatrizEditarRoutingModule { }
